import { Button } from '@pata-app/ui-form';

import React from 'react';

import { getEnv } from '../../lib/utils/getEnv';
import { ActionContainer } from './callToActionButtons.styled';

const { VITE_PARTNERS_BASE_URL } = getEnv();

export function CallToActionButtons() {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <ActionContainer>
      <Button onClick={handleSignUpClick}>Sign up for free</Button>
      <Button buttonType="secondary" onClick={handleBookDemo}>
        Book a demo
      </Button>
    </ActionContainer>
  );
}
